<template>
  <div>
    <table-card
      ref="datatable"
      module="PoiIcon"
      :headers="headers"
      :actions="actions"
    >
      <template v-slot:action>
        <vs-button
          color="primary"
          type="gradient"
          class="mb-4 md:mb-0"
          @click="add"
          >Add New Data</vs-button
        >
      </template>
    </table-card>

    <vs-popup
      classContent="popup-example"
      :title="popupTitle"
      :active.sync="showPopup"
    >
      <template>
        <div class="vx-row mb-6">
          <div class="vx-col w-full">
            <vs-input label="Name" class="w-full" v-model="input.name" />
          </div>
          <div class="vx-col w-full">
            <label class="vs-input--label">Icon</label>
            <input
              type="file"
              label="Icon"
              @change="handleFile('icon')"
              ref="icon"
              class="w-full file-input"
            />
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col w-full ml-auto">
            <vs-button
              :disabled="isSubmit"
              id="submitBtn"
              class="mr-3 mb-2 vs-con-loading__container"
              @click="submit"
              >Submit</vs-button
            >
            <vs-button
              :disabled="isSubmit"
              v-show="action === 'store'"
              color="warning"
              type="border"
              @click="reset"
              class="mb-2"
              >Reset</vs-button
            >
          </div>
        </div>
      </template>
    </vs-popup>
  </div>
</template>

<script>
import TableCard from '@/components/TableCard'

export default {
  components: {
    TableCard
  },

  data() {
    return {
      isSubmit: false,
      showPopup: false,
      popupTitle: '',
      action: '',
      input: {
        id: null,
        name: null,
        icon: null
      },
      file: {}
    }
  },

  computed: {
    headers() {
      return [
        [
          { label: 'Name', value: 'name' },
          { label: 'Icon', value: 'icon', formatter: this.showIcon }
        ]
      ]
    },
    actions() {
      return [
        {
          name: 'Edit',
          action: this.edit,
          icon: 'icon-edit',
          color: 'success'
        },
        {
          name: 'Delete',
          action: this.del,
          icon: 'icon-trash',
          color: 'danger'
        }
      ]
    },
    imgSource() {
      return `${this.$api.base_url}/uploads/icon`
    }
  },

  watch: {},
  created() {},
  mounted() {},

  methods: {
    initTable() {
      this.$refs.datatable.initTable()
    },

    reset() {
      Object.keys(this.input).map((item) => {
        this.input[item] = null
      })
      this.$refs['icon'].value = ''
    },

    handleFile(key) {
      this.file[key] = this.$refs[key].files[0]
    },

    add() {
      this.reset()
      this.action = 'store'
      this.popupTitle = 'Add POI Icon'
      this.showPopup = true
    },

    async edit(id) {
      this.$refs['icon'].value = ''
      this.input.id = id
      this.action = 'update'
      this.popupTitle = 'Edit POI Icon'

      await this.$store.dispatch('PoiIcon/detail', id).then((data) => {
        this.input.name = data.name
      })
      this.showPopup = true
    },

    async submit() {
      this.isSubmit = true
      this.loadingStart('#submitBtn', 'primary')

      const data = {
        ...this.input,
        icon: typeof this.file.icon !== 'undefined' ? this.file.icon : null
      }

      const { status, message } = await this.$store.dispatch(
        `PoiIcon/${this.action}`,
        data
      )
      this.isSubmit = false
      this.loadingStop('#submitBtn')
      if (status) {
        this.showNotify(message)
        this.initTable()
        this.reset()
        this.showPopup = false
      }
    },

    del(id) {
      this.input.id = id
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: `Delete POI Icon`,
        text: 'Are you sure want to Delete this POI Icon ?',
        accept: this.confirmDelete
      })
    },

    async confirmDelete() {
      const { status, message } = await this.$store.dispatch(
        'PoiIcon/delete',
        this.input.id
      )
      if (status) {
        this.showNotify(message)
        this.initTable()
      }
    },

    loadingStart(el, color = 'success') {
      this.$vs.loading({
        background: color,
        color: '#fff',
        container: el,
        scale: 0.45
      })
    },

    loadingStop(el) {
      this.$vs.loading.close(`${el} > .con-vs-loading`)
    },

    showNotify(msg, type = 'success') {
      this.$vs.notify({
        title: 'Thank You',
        text: msg,
        color: type,
        position: 'top-right'
      })
    },

    showIcon(data) {
      return `<img style="width: 50px; height: 50px;" src="${data}" alt="">`
    }
  }
}
</script>
